
export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      myIndex: 0,
      carouselTimeout: null
    };
  },
  mounted() {
    this.carousel();
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  },
  beforeDestroy() {
    if (this.carouselTimeout) {
      clearTimeout(this.carouselTimeout);
    }
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  },
  methods: {
    carousel() {
      const slides = document.getElementsByClassName('img-slide');
      if (!slides) {
        return;
      }

      for (let i = 0; i < slides.length; i++) {
        slides[i].style.opacity = '0';
      }

      this.myIndex++;
      if (this.myIndex > slides.length) {
        this.myIndex = 1;
      }

      slides[this.myIndex - 1].style.opacity = '1';

      this.carouselTimeout = setTimeout(() => this.carousel(), 5000);
    },
    handleVisibilityChange() {
      if (document.hidden) {
        // Pause carousel when page is not visible
        clearTimeout(this.carouselTimeout);
      } else {
        // Restart carousel when page becomes visible
        this.carousel();
      }
    }
  }
};
